var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVisitorsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296 994.653 221.347 920 516 624.912l140 140 207-207L938.088 633 656 914.653l-140-140-220 220Zm-129.217-39.435q-44.305 0-75.153-30.848-30.848-30.848-30.848-75.153V302.783q0-44.305 30.848-75.153 30.848-30.848 75.153-30.848h546.434q44.305 0 75.153 30.848 30.848 30.848 30.848 75.153v165.739H166.783v486.696Zm0-587.045h546.434v-65.39H166.783v65.39Zm0 0v-65.39 65.39Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisitorsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visitorsIcon.386bb74e.svg";
export { ForwardRef as ReactComponent };